




import Vue from 'vue'

export default Vue.extend({
    data() {
        let version = require('../../package.json').version
        return {
            version: version
        }
    }
})
